import React from "react";
import Hero from './DroneRepair/Hero';
import MagicBento from './DroneRepair/MagicBento';
import CertificationMumbaiChandigarh from "./CertificationMumbaiChandigarh";
import WhoCanApply from "./WhoCanApply";

const DroneRepair = () => {

  return (
    <>
      <Hero />
      <WhoCanApply />
      <MagicBento />
      <CertificationMumbaiChandigarh />
    </>
  );
};

export default DroneRepair;
